import React, { useState } from 'react';
import { api } from '@unicus/react-ui-kit';
import { Alert, Button, Col, Modal, Row, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import useAuth from 'core/hooks/useAuth';

const extensions = ['application/pdf'];

const UploadRegistrationStatementModal = () => {
  const { isRequiredRegistrationStatement, refresh, refreshToken } = useAuth();
  const [visible, setVisible] = useState(isRequiredRegistrationStatement);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = () => {
    const formData = new FormData();

    fileList.forEach((file) => {
      formData.append('file', file);
      formData.append('type', 'attachment');
    });

    setUploading(true);

    api
      .post('student-accounts/registration-statement', formData)
      .then((res) => {
        if (res.status !== 200 && res?.message) {
          throw new Error(res?.message);
        }
      })
      .then(() => {
        setFileList([]);
        refresh({ refreshToken, type: 'professional' });
        message.success('Declaração de matrícula enviada.');
        setVisible(false);
      })
      .catch((error) => {
        message.error(error?.message ?? 'Ocorreu um erro ao enviar o arquivo.');
      })
      .finally(() => {
        setUploading(false);
      });
  };

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      if (!extensions.includes(file.type.toLowerCase())) {
        message.error('É permitido somente arquivos com a extensão .pdf');
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        message.error('O tamanho do arquivo não pode ser superior a 2MB');
        return false;
      }

      setFileList([...fileList, file]);

      return false;
    },
    fileList
  };

  return (
    <Modal
      title="Declaração de matrícula para estudantes"
      visible={visible}
      onCancel={() => setVisible(false)}
      width={800}
      footer={
        <Button
          type="primary"
          onClick={handleUpload}
          disabled={fileList.length === 0}
          loading={uploading}
        >
          {uploading ? 'Enviando' : 'Enviar'}
        </Button>
      }
    >
      <Row align="middle" justify="space-around">
        <Col span={16}>
          <Alert
            message="Declaração de matrícula"
            description="Envie sua declaração de matrícula para validar sua conta."
            type="warning"
            showIcon
          />
        </Col>
        <Col span={8}>
          <Upload {...props}>
            <Button icon={<UploadOutlined />} disabled={fileList.length > 0}>
              Selecione o arquivo (*.pdf)
            </Button>
          </Upload>
        </Col>
      </Row>
    </Modal>
  );
};

export default UploadRegistrationStatementModal;
